import React from 'react';
import styled from 'styled-components';
import { MenuTemplate } from './MenuTemplate';
import { rem } from 'polished';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV } from '../../constants/main';
import { StylesAC } from './Styles.AC';
import { StylesAP } from './Styles.AP';
import { StylesDS } from './Styles.DS';
import { StylesOV } from './Styles.OV';

export const SidebarMenu = styled(MenuTemplate)`
    nav {
        justify-content: flex-start;
    }

    ul {
        margin: 0;
        padding-left: ${rem('15px')};
        padding-bottom: ${rem('30px')};
        list-style: none;
    }

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && StylesOV};
`;
